import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "uk-container uk-background-muted" }
const _hoisted_2 = {
  class: "uk-section uk-light uk-background-cover",
  style: {"background-image":"linear-gradient(rgba(22, 36, 56, 0.5), rgba(1, 7, 14, 0.68)), url(\"https://unsplash.com/photos/nfQk1YdGoNc/download?force=true&w=1920\")"}
}
const _hoisted_3 = { class: "uk-container white-text" }
const _hoisted_4 = { class: "uk-card-default uk-margin-top uk-padding" }
const _hoisted_5 = { class: "uk-text-left" }
const _hoisted_6 = { class: "uk-card-default uk-margin-top uk-padding" }
const _hoisted_7 = { class: "uk-text-left" }
const _hoisted_8 = { class: "uk-card-default uk-margin-top uk-padding" }
const _hoisted_9 = { class: "uk-text-left" }
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeIcon = _resolveComponent("HomeIcon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.dataLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_Button, {
            isSecondary: true,
            onClick: _ctx.navigateToCityDirectoryPage,
            class: "uk-margin uk-margin-top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_HomeIcon),
              _createTextVNode(" Back to " + _toDisplayString(_ctx.company.directoryEntry.companyDirectoryCity) + " directory ", 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.company.name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "uk-text-left" }, "Contact Info", -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", null, "Address: " + _toDisplayString(_ctx.fullAddress(_ctx.company.officeAddress)), 1),
              _createElementVNode("p", null, "Email: " + _toDisplayString(_ctx.company.email), 1),
              _createElementVNode("p", null, "Phone #: " + _toDisplayString(_ctx.company.phoneNumber), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "uk-text-left uk-margin-remove-bottom" }, "Who We Are", -1)),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.company.description), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "uk-text-left uk-margin-remove-bottom" }, "Services Offered", -1)),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.company.servicesOffered), 1)
          ]),
          _createElementVNode("a", {
            class: "uk-text-medium uk-button uk-button-primary uk-margin uk-padding",
            href: 'mailto:' + _ctx.company.email
          }, "Request a rate quotation", 8, _hoisted_10),
          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
          _cache[4] || (_cache[4] = _createElementVNode("div", {
            class: "uk-section uk-light uk-background-cover uk-margin-bottom",
            style: {"background-image":"linear-gradient(rgba(22, 36, 156, 0.7), rgba(1, 7, 14, 0.68)), url(\"https://unsplash.com/photos/7n0JF9WvpJQ/download?force=true&w=1920\")"}
          }, [
            _createElementVNode("div", { class: "uk-container white-text" })
          ], -1))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}